import { createCustomEnum } from "./customEnum";

const ShippingMethodTypes = createCustomEnum({
	none: {
		name: "none",
		value: 0,
		displayName: "None",
	},
	ground: {
		name: "ground",
		value: 1,
		displayName: "Ground",
	},
	two_day: {
		name: "two_day",
		value: 2,
		displayName: "2-Day",
	},
	overnight: {
		name: "overnight",
		value: 3,
		displayName: "Overnight",
	},
	priority: {
		name: "priority",
		value: 4,
		displayName: "Priority",
	},
});

export default ShippingMethodTypes;
